export default {
  path: '/island-vacation',
  component: () => import('@/views/island-vacation/Index'),
  redirect: { name: 'island-vacation-groups-list' },
  children: [
    {
      path: 'groups',
      component: () => import('@/views/island-vacation/groups/Index'),
      children: [
        {
          path: '',
          name: 'island-vacation-groups-list',
          component: () => import('@/views/island-vacation/groups/List'),
          meta: {
            title: 'Groups list',
            roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor', 'support']
          }
        },
        {
          path: ':id',
          component: () => import('@/views/island-vacation/groups/detail/Layout'),
          children: [
            {
              path: '',
              name: 'island-vacation-groups-detail-clients',
              component: () => import('@/views/island-vacation/groups/detail/Clients'),
              meta: {
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor', 'support']
              }
            },
            {
              path: 'itinerary',
              name: 'island-vacation-groups-detail-itinerary',
              component: () => import('@/views/island-vacation/groups/detail/Itinerary'),
              meta: {
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor', 'support']
              }
            },
          ]
        }
      ]
    }
  ]
}